export default __webpack_public_path__ + "static/media/BG_Logo.010af1f7.svg";